import {
  onBeforeUnmount,
  ref,
  watch,
  type MaybeRefOrGetter,
  toValue,
} from "vue";

export interface ITypingOptions {
  speed?: number; // 打字速度，每个字符之间的间隔时间（毫秒）
}

export const useTyping = (
  text: MaybeRefOrGetter<string>,
  options: ITypingOptions = {}
) => {
  const { speed = 50 } = options;

  const displayText = ref("");
  const isPlaying = ref(false);
  let timer: NodeJS.Timeout | null = null;

  // 清理定时器
  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  // 重置状态
  const reset = () => {
    clearTimer();
    displayText.value = "";
    isPlaying.value = false;
  };

  // 监听文本变化，重置状态
  watch(
    () => toValue(text),
    () => {
      reset();
    }
  );

  // 打字机效果的核心逻辑
  const typeNextChar = (currentIndex: number) => {
    const currentText = toValue(text);
    if (currentIndex >= currentText.length) {
      isPlaying.value = false;
      return;
    }

    displayText.value += currentText[currentIndex];
    timer = setTimeout(() => {
      typeNextChar(currentIndex + 1);
    }, speed);
  };

  // 开始播放打字效果
  const play = () => {
    if (isPlaying.value) return;

    reset();
    isPlaying.value = true;
    typeNextChar(0);
  };

  // 直接显示完整文本
  const goToEnd = () => {
    clearTimer();
    displayText.value = toValue(text);
    isPlaying.value = false;
  };

  // 组件卸载时清理
  onBeforeUnmount(() => {
    clearTimer();
  });

  return {
    // 状态
    displayText,
    isPlaying,

    // 方法
    play,
    goToEnd,
  };
};
